<template>
    <div v-if="isVisible" class="row">
        <strong class="col-xs-6 col-sm-5"></strong>
        <span class="col-xs-6 col-sm-7">
            <button class="btn btn-primary btn-block" :disabled="isLoading" @click="prepareCheckout()">
                {{ label }}
            </button>
            <div v-if="failed" class="alert alert-danger m-t-1">
                Error while trying to prepare payment
            </div>
        </span>
    </div>
</template>

<script>

    import ReInitBaseComponent from './ReInitBaseComponent';

    export default {
        extends: ReInitBaseComponent
    }
</script>

<style scoped>
    button {
        margin-top: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/ReInitPaymentContainer.vue